import React from 'react';
import * as Accordion from '@radix-ui/react-accordion';
import { ChevronDownIcon } from 'lucide-react';
export const FAQ = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  const faqs = [{
    question: 'Как понять, нужна ли мне психотерапия?',
    answer: 'Если вы чувствуете, что не справляетесь самостоятельно, испытываете постоянный дискомфорт, тревогу, апатию или сложности в отношениях — это повод обратиться к психологу. Терапия помогает не только в кризисных ситуациях, но и для личностного роста и самопознания.'
  }, {
    question: 'Сколько длится терапия?',
    answer: 'Длительность зависит от запроса и целей. Краткосрочная терапия занимает до 10 сессий, долгосрочная — от нескольких месяцев до года и более. Мы обсуждаем это на первой встрече и регулярно оцениваем прогресс.'
  }, {
    question: 'Как часто нужно встречаться?',
    answer: 'Обычно я рекомендую встречаться раз в неделю, это оптимальная частота для поддержания динамики работы. В некоторых случаях возможны встречи раз в две недели или чаще — всё зависит от вашей ситуации и возможностей.'
  }, {
    question: 'Что делать, если я не знаю, с чего начать?',
    answer: 'Это нормально! На первой встрече мы вместе разберёмся, что вас беспокоит, сформулируем запрос и наметим направление работы. Иногда сам процесс разговора помогает прояснить, что важно.'
  }, {
    question: 'Можно ли отменить или перенести сессию?',
    answer: 'Да, но прошу предупреждать минимум за 24 часа. Если отменить встречу позже, сессия оплачивается полностью. Это помогает поддерживать структуру терапии и уважать время друг друга.'
  }, {
    question: 'Как проходят онлайн-сессии?',
    answer: 'Мы встречаемся через защищённую видеосвязь (Zoom или Яндекс.Телемост). Важно, чтобы у вас было тихое место, где вас никто не побеспокоит, и стабильный интернет.'
  }, {
    question: 'Где проходят границы моей помощи?',
    answer: 'Я могу проводить клиническую диагностику и помогать разобраться, что с вами происходит, но у меня нет права выписывать официальные документы. Я не смогу оформить рецепты на лекарства (антидепрессанты, нейролептики и другие препараты), выдать медицинские справки, больничные или заключения для работодателя, вуза, суда и т.п. Если мы увидим, что нужны медикаменты, я порекомендую вам психиатра или другого врача.'
  }];
  return <section className="w-full py-8 px-6 md:px-10 bg-gradient-to-b from-white to-gray-50 relative overflow-hidden" data-id="element-109">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#3d8f5a]/5 rounded-full blur-3xl" data-id="element-110" />
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-111">
        <div className="text-center mb-6" data-id="element-112">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900" data-id="element-113">
            Часто задаваемые вопросы
          </h2>
        </div>
        <Accordion.Root type="single" collapsible className="space-y-2" data-id="element-114">
          {faqs.map((faq, index) => <Accordion.Item key={index} value={`item-${index}`} className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-md transition-all" data-id="element-115">
              <Accordion.Header data-id="element-116">
                <Accordion.Trigger className="w-full flex justify-between items-center p-4 text-left hover:bg-gray-50 transition-colors group" data-id="element-117">
                  <span className="text-sm md:text-base font-semibold text-gray-900 pr-4" data-id="element-118">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className="w-4 h-4 text-[#3d8f5a] flex-shrink-0 transition-transform duration-300 group-data-[state=open]:rotate-180" data-id="element-119" />
                </Accordion.Trigger>
              </Accordion.Header>
              <Accordion.Content className="overflow-hidden data-[state=open]:animate-slideDown data-[state=closed]:animate-slideUp" data-id="element-120">
                <div className="px-4 pb-4 text-sm text-gray-700 leading-relaxed" data-id="element-121">
                  {faq.answer}
                </div>
              </Accordion.Content>
            </Accordion.Item>)}
        </Accordion.Root>
        <div className="mt-6 text-center" data-id="element-122">
          <p className="text-sm text-gray-600 mb-3" data-id="element-123">
            Не нашли ответ на свой вопрос?
          </p>
          <button onClick={scrollToContact} className="px-6 py-2.5 bg-[#3d8f5a] text-white text-sm font-semibold rounded-xl hover:bg-[#2c5f2d] transition-colors" data-id="element-124">
            Задать вопрос
          </button>
        </div>
      </div>
    </section>;
};